// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__WZ2HF","vatRate":"styles_vatRate__EXqDL","vatRateLabel":"styles_vatRateLabel__wfeJm","slideInSearchBar":"styles_slideInSearchBar__epgJQ"};